import { createClient } from "@supabase/supabase-js"
import { SUPABASE_ANON_KEY, SUPABASE_API_URL, SUPABASE_OPTIONS } from "./const"
import { Database } from 'types/supabase'

export const supabaseClient = createClient<Database>(
  SUPABASE_API_URL,
  SUPABASE_ANON_KEY,
  // @ts-ignore
  SUPABASE_OPTIONS
)
